var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-pagination',{attrs:{"current-page":_vm.page,"background":"","layout":_vm.layout,"total":_vm.total,"page-sizes":_vm.pageSizes},on:{"current-change":_vm.pageChange,"size-change":_vm.sizeChange}})}
var staticRenderFns = []

export { render, staticRenderFns }